// Reusable default sizes/etc. for common-ui components.
// It's up to the components which use these to decide how to use them.

// TODO: Actually set these to reasonable values
const constants = {
  spacing: {
    md: "0.5rem",
    lg: "1rem",
  },
  shadow: "0 0 1rem 0.2rem rgba(112, 91, 91, 0.25)",
  radius: "0.3rem",
  lengths: {
    xs: "0.3rem",
    sm: "0.5rem",
    md: "0.7rem",
    lg: "1rem",
    xl: "1.5rem",
    xxl: "2rem",
  },
} as const;

export default constants;
